
// General
export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';

// Modal windows
export const UPDATE_LOGIN_MODAL = 'UPDATE_LOGIN_MODAL';
export const UPDATE_ADD_HACK_MODAL = 'UPDATE_ADD_HACK_MODAL';
export const UPDATE_SHARE_NEWS_MODAL = 'UPDATE_SHARE_NEWS_MODAL';
export const UPDATE_ADD_REVIEW_MODAL = 'UPDATE_ADD_REVIEW_MODAL';
export const CLOSE_ALL_MODALS = 'CLOSE_ALL_MODALS';
export const UPDATE_RESET_PASSWORD_MODAL = 'UPDATE_RESET_PASSWORD_MODAL';

// Modal about
export const UPDATE_COMPANY_MODAL = 'UPDATE_COMPANY_MODAL';
export const UPDATE_HACKER_MODAL = 'UPDATE_HACKER_MODAL';
export const UPDATE_ORGANIZER_MODAL = 'UPDATE_ORGANIZER_MODAL';

// AUTH
export const LOGIN = 'LOGIN';
export const LOGIN_WITH_TOKEN = 'LOGIN_WITH_TOKEN';
export const LOGOUT = 'LOGOUT';
export const REGISTER = 'REGISTER';
export const LOGIN_PAGE_UNLOADED = 'LOGIN_PAGE_UNLOADED';
export const UPDATE_ACTIVE_FORM = 'UPDATE_ACTIVE_FORM';
export const LOGGED_IN = 'LOGGED_IN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';

// User
export const SET_USER = 'SET_USER';
export const GET_USER_WALLET = 'GET_USER_WALLET';
export const GET_USER_EVENTS = 'GET_USER_EVENTS';
export const SET_USER_PROJECTS = 'SET_USER_PROJECTS';
export const RESET_USER = 'RESET_USER';
export const UPDATE_SOCIAL_NETWORKS = 'UPDATE_SOCIAL_NETWORKS';
export const UPDATE_SKILLS_AND_ROLES = 'UPDATE_SKILLS_AND_ROLES';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js